import * as React from "react";
import { TrustedShopsWidgetComponent } from "@grandvisionhq/analytics";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
const CmsWidgetTrustedShop = ({ meta: { scriptID } }) => {
  if (!scriptID || scriptID.trim() === "") {
    return null;
  }
  return /* @__PURE__ */ React.createElement(TrustedShopsWidgetComponent, { id: scriptID });
};
const WidgetTrustedShop = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachData,
  withAnchor
)(CmsWidgetTrustedShop);
export {
  CmsWidgetTrustedShop,
  WidgetTrustedShop as default
};
//# sourceMappingURL=WidgetTrustedShop.js.map
